var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectArticle',{staticClass:"SelectArchArticle ib",attrs:{"articleIdExcluded":_vm.article.id,"siteId":_vm.article.siteId,"value":_vm.article.archArticleId},on:{"update:value":function($event){return _vm.$up('value', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }